export const PerformanceJson = {
  kpis: [
    {
      id: "1",
      task: "Increase Sales by 10%",
      accomplishment:
        "Implemented new marketing strategy resulting in a 15% increase",
      staff_rating: 4,
      supervisor_rating: 3,
    },
    {
      id: "2",
      task: "Improve Customer Satisfaction",
      accomplishment:
        "Introduced live chat support, leading to a 20% increase in positive feedback",
      staff_rating: 3,
      supervisor_rating: 4,
    },
    {
      id: "3",
      task: "Reduce Operational Costs",
      accomplishment:
        "Identified inefficiencies, saving 25% in operational expenses",
      staff_rating: 1,
      supervisor_rating: 3,
    },
  ],
  StaffID: "tmp@xyz.com",
  DepartmentID: 1,
  AppraisalPeriodID: "646128cc9bd2203193b8b3ff",
  Submitted: false,
  Validated: false,
};


export const PerformanceJsonB = {
  kpis: [
    {
      id: "1",
      rating_factor:{
        title: "WORK QUALITY",
        description: "Displays accuracy, thoroughness, and attention to detail in work."
      },
      staff_rating: {
        rate: 4,
        comment: "I completed the project and no other project to do  \n Introduced live chat support, leading to a 20% increase in positive feedback \n Introduced live chat support, leading to a 20% increase in positive feedback Introduced live chat support, leading to a 20% increase in positive feedback Introduced live chat support, leading to a 20% increase in positive feedback \n Introduced live chat support, leading to a 20% increase in positive feedback"
      },
      supervisor_rating: {
        rate: 4,
        comment: "I completed the project and no other project to do"
      }
    },
    {
      id: "2",
      rating_factor:{
        title: "ROLE KNOWLEDGE",
        description: "Demonstrates knowledge of job duties, responsibilities, skills, and organizational procedures; displays ability to apply job knowledge to unique situations and understands how job fits into institutional operations and objectives."
      },
      staff_rating: {
        rate: 4,
        comment: "I completed the project and no other project to do"
      },
      supervisor_rating: {
        rate: 4,
        comment: "I completed the project and no other project to do"
      }
    },
    {
      id: "3",
      rating_factor:{
        title: "DEPENDABILITY",
        description: "Demonstrates consistency in production of desired results follows through on task completion; meets time schedules."
      },
      staff_rating: {
        rate: 4,
        comment: "I completed the project and no other project to do"
      },
      supervisor_rating: {
        rate: 4,
        comment: "I completed the project and no other project to do"
      }
    },
  ],
  StaffID: "tmp@xyz.com",
  DepartmentID: 1,
  AppraisalPeriodID: "646128cc9bd2203193b8b3ff",
  Submitted: false,
  Validated: false,
};
